// ModuloCompras.jsx
import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Container,
  Avatar,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tabs,
  Tab,
  Grid,
  CssBaseline,
  Stack,
  TextField,
  IconButton,
} from '@mui/material';
import { StyledCellHeader } from '../../../../components/StyledCellHeader';
import { Add, RemoveRedEye, RemoveRedEyeOutlined, ShoppingCart, TrendingUp, Assessment, Inventory } from '@mui/icons-material';
import CrearOrdenCompraDialog from './crearordencompradialog';
import { useNavigate } from 'react-router-dom';
import AccessDeniedBox from '../../../../components/AccessDeniedBox';
import EmptyState from '../../../../components/EmptyState';


const OrdenesCompras = (props) => {
  const navigate = useNavigate();
  const [tab, setTab] = React.useState(0);
  const [openDialogOrdenCompra, setOpenDialogOrdenCompra] = useState(false)

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const [ordenes, setOrdenes] = useState([]);

  const [accessDenied, setAccessDenied] = useState(false);

  useEffect(() => {
    fetch(process.env.REACT_APP_SERVER_URL+`/api/ordenes-compra/${localStorage.getItem('idcompany')}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany'), 
      },
    }).then((response) => response.json()).then((data) => {
      console.log(data)
      if(data["error"]!="Acceso denegado"){
        setAccessDenied(false);
        setOrdenes(data);
      }else{
        setAccessDenied(true);
      }
    });
  }, []);

  const handleVerOrden = (id) => {
    navigate(`/logistica/compras/ordenes-compra/${id}`)
  }

  return (
    <Box>
        {openDialogOrdenCompra&&
        <CrearOrdenCompraDialog open={openDialogOrdenCompra} onClose={()=>{setOpenDialogOrdenCompra(false)}}/>
        }

        {!openDialogOrdenCompra && (
          <>
          {!accessDenied ? 
        <Box>

            <Box display="flex" justifyContent="flex-end" mb={2}>
                <Button onClick={()=>{setOpenDialogOrdenCompra(true)}} variant="contained" color='primarybutton' startIcon={<Add/>} sx={{ fontWeight:"bold" }}>Crear nueva orden</Button>
            </Box>

            <Box padding={2}>
                {/* Show empty state if no orders */}
                {ordenes.length === 0 ? (
                    <EmptyState 
                        icon={ShoppingCart}
                        title="No hay órdenes de compra"
                        description="Comienza creando tu primera orden de compra para gestionar las adquisiciones de productos y servicios de manera eficiente."
                        features={[
                            {
                                icon: Inventory,
                                title: "Gestión de Inventario",
                                description: "Control completo de compras y stock"
                            },
                            {
                                icon: TrendingUp,
                                title: "Seguimiento de Proveedores",
                                description: "Monitoreo de entregas y rendimiento"
                            },
                            {
                                icon: Assessment,
                                title: "Reportes de Compras",
                                description: "Análisis de costos y gastos"
                            }
                        ]}
                        buttonText="Crear Primera Orden de Compra"
                        onButtonClick={() => setOpenDialogOrdenCompra(true)}
                        helpText="¿Necesitas ayuda? Contacta a soporte técnico para guiarte en el proceso"
                    />
                ) : (
                    <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: "none", minHeight: "500px", mt: 2 }}>
                        <Table >
                            <TableHead>
                                <TableRow>
                                    <StyledCellHeader align="center"># Orden</StyledCellHeader>
                                    <StyledCellHeader>Proveedor</StyledCellHeader>
                                    <StyledCellHeader>Fecha</StyledCellHeader>
                                    <StyledCellHeader align='center'>Estado</StyledCellHeader>
                                    <StyledCellHeader>Total</StyledCellHeader>
                                    <StyledCellHeader>Acciones</StyledCellHeader>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {ordenes.map((orden) => (
                                <TableRow key={orden.numero_orden}>
                                <TableCell align="center">{orden.numero_orden}</TableCell>
                                <TableCell>{orden.proveedor_name}</TableCell>
                                <TableCell>{orden.fecha_emision}</TableCell>
                                <TableCell align='center'>
                                    <Button variant="outlined" size="small" fullWidth>
                                    {orden.estado}
                                    </Button>
                                </TableCell>
                                <TableCell>{orden.total_estimado}</TableCell>
                                <TableCell>
                                    <IconButton size="small" sx={{ color: "#617689" }} onClick={()=>{handleVerOrden(orden.id)}}>
                                      <RemoveRedEyeOutlined/>
                                    </IconButton>
                                </TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Box>

        </Box>
        :
        <Box>
          <br></br>
          <br></br>
          <AccessDeniedBox
            title={'Acceso denegado'}
            message={'No tienes permisos para ver esta sección de Órdenes de Compra. Contacta a tu administrador para solicitar acceso o verifica tus roles y permisos.'}
          />
        </Box>
        }
        </>
        )}
    </Box>
  );
};

export default OrdenesCompras;
